export default __webpack_public_path__ + "static/media/67-min.216914a9.jpg";